var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 0.650391H2.00039C1.25481 0.650391 0.650391 1.25481 0.650391 2.00039V11.0004C0.650391 11.746 1.25481 12.3504 2.00039 12.3504H16.0004C16.746 12.3504 17.3504 11.746 17.3504 11.0004V2.00039C17.3504 1.25481 16.746 0.650391 16.0004 0.650391Z",
    stroke: "#455079",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4202 6.5007L8.30026 5.26405V7.73736L10.4202 6.5007ZM12.0156 6.5007C12.0156 6.83612 11.8503 7.17154 11.5195 7.36448L8.50413 9.12344C7.83747 9.51232 7.00026 9.03145 7.00026 8.25966V4.74174C7.00026 3.96995 7.83747 3.48907 8.50413 3.87796L11.5195 5.63692C11.8503 5.82986 12.0156 6.16528 12.0156 6.5007Z",
    fill: "#455079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.0dea380658711c22091ceb2873176661.svg";
export { ForwardRef as ReactComponent };